export const FormField = ({ label, children }) => (
  <div className="my-2 font-MTNfont">
    <label className="block mb-0.5 font-MTNfont">{label}</label>
    {children}
      
  </div>
);
export default FormField;
